import { addFooter, headerReport } from "../../reports/configs/utils";
import jsPDF from "jspdf";
import dayjs from "dayjs";

const defaultConfigStylesTable = {
    fontSize: 9,
    overflow: 'linebreak',
    cellPadding: 3,
};

const unit = "pt";
const size = "A4";
const orientation = "portrait";

const STATUS_LABEL = {
    livre: 'Livre',
    ocupado: 'Ocupado',
    desativado: 'Inativada',
    inativado: 'Inativada',
    aguardando: 'Aguardando',
    grouped: 'Agrupada',
};

const STATUS_FILL = {
    livre: [232, 245, 233],
    ocupado: [255, 243, 224],
    aguardando: [227, 242, 253],
    inativado: [245, 245, 245],
    desativado: [245, 245, 245],
    grouped: [237, 231, 246],
};

const STATUS_TEXT = {
    livre: [46, 90, 54],
    ocupado: [140, 90, 20],
    aguardando: [25, 80, 140],
    inativado: [130, 130, 130],
    desativado: [130, 130, 130],
    grouped: [90, 60, 140],
};

function capitalize(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function normalizarStatus(status) {
    if (!status) return 'Livre';
    return STATUS_LABEL[status] ?? capitalize(status);
}

function resolveProdutoNome(idProduto, produtos) {
    if (!idProduto) return null;

    for (const prod of produtos) {
        if (prod.id === idProduto) {
            return (prod.ca ? `CA: ${prod.ca} - ` : '') + prod.nome;
        }
        const filho = prod.filhos?.find(f => f.id === idProduto);
        if (filho) {
            const base = (prod.ca ? `CA: ${prod.ca} - ` : '') + prod.nome;
            const variacao = filho.variacao?.tipo ? ` (${filho.variacao.tipo})` : '';
            return base + variacao;
        }
    }
    return null;
}

export function exportConfigToPDF({
                                      linhas = [],
                                      produtos = [],
                                      selectedEmpresa,
                                      dadosUsuario,
                                      titulo = '',
                                      unidadeLabel = 'Slot',
                                      reportName = 'configuracoes',
                                      reportTitle = 'CONFIGURAÇÕES DO EQUIPAMENTO',
                                  }) {
    const doc = new jsPDF(orientation, unit, size);

    const strokeWidth = reportTitle.length * 8.3;
    headerReport(doc, selectedEmpresa, reportTitle, strokeWidth);

    let startY = selectedEmpresa ? 105 : 90;

    doc.autoTable({
        startY,
        head: [['Equipamento', 'Tipo', 'Emitido em']],
        body: [[
            titulo || '-',
            unidadeLabel === 'Motores' ? 'Máquina' : 'Armário',
            dayjs().format('DD/MM/YYYY HH:mm'),
        ]],
        theme: 'grid',
        headStyles: { fillColor: [30, 81, 57], textColor: 255, fontStyle: 'bold' },
        styles: defaultConfigStylesTable,
        didDrawPage: (data) => addFooter(doc, data, dadosUsuario.pessoa),
    });

    startY = doc.lastAutoTable.finalY + 6;

    const isLocker = unidadeLabel !== 'Motores';

    const body = linhas.map((l) => {
        const nome = resolveProdutoNome(l.id_produto, produtos);
        const statusLabel = normalizarStatus(l.status);

        let posicao = l.label ?? String(l.numero ?? '-');
        if (isLocker && (l.grupo || l.agrupado)) {
            const detalheGrupo = typeof l.grupo === 'string' ? l.grupo : (l.portasFisicas?.join(', ') ?? '');
            posicao = detalheGrupo
                ? `${posicao} (grupo: ${detalheGrupo})`
                : `${posicao} (agrupada)`;
        }

        const row = [
            posicao,
            statusLabel,
            nome ?? 'Sem produto',
            String(l.quantidade ?? 0),
        ];

        return { row, inativa: statusLabel === 'Inativada', statusRaw: l.status ?? 'livre' };
    });

    doc.autoTable({
        startY,
        head: [[unidadeLabel, 'Status', 'Produto', 'Quantidade']],
        body: body.length > 0 ? body.map(b => b.row) : [['-', '-', 'Nenhum slot configurado', '-']],
        theme: 'grid',
        headStyles: { fillColor: [30, 81, 57], textColor: 255, fontStyle: 'bold' },
        columnStyles: {
            0: { cellWidth: 110 },
            1: { cellWidth: 70 },
            3: { cellWidth: 80, halign: 'right' },
        },
        styles: defaultConfigStylesTable,
        didParseCell: (data) => {
            if (data.section !== 'body') return;

            const meta = body[data.row.index];
            if (!meta) return;

            if (data.column.index === 1) {
                const fill = STATUS_FILL[meta.statusRaw];
                const text = STATUS_TEXT[meta.statusRaw];
                if (fill) data.cell.styles.fillColor = fill;
                if (text) data.cell.styles.textColor = text;
                data.cell.styles.fontStyle = 'bold';
                return;
            }

            if (meta.inativa) {
                data.cell.styles.textColor = [130, 130, 130];
                data.cell.styles.fillColor = [245, 245, 245];
            }
        },
        didDrawPage: (data) => addFooter(doc, data, dadosUsuario.pessoa),
    });

    doc.save(`${reportName}_${dayjs().format('YYYY-MM-DD_HHmm')}.pdf`);
}